export default () => ({
  filter: 'all',
  submissions: []
})
